// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { toAbsoluteApiUrl } from "../../../../_metronic/_helpers";
import { useModuleContext } from "../ModuleContext";
import {AESVG} from "../../../../_emywork/components/svg";
import {AEButton} from "../../../../_emywork/components/buttons";
import {AERole} from "../../../../_emywork/components/AERole";
import {useIntl} from "react-intl";
import {PAYMENT_TERMS, localField, AETruncate} from "../../../../_emywork/helpers/UIHelper";
import {AECurrency} from "../../../../_emywork/components/Currency";
import {roles} from "../../../../index";
import {CONTEXT} from "../../Users/helpers/ModuleHelpers";
import {AEAvatar} from "../../../../_emywork/components/AEAvatar";
import {AELink} from "../../../../_emywork/components/AELink";


export function EntityCard({
                             entity,
                             size= "md",
                             editAction = false,
                             detailsAction = false,
                             sendProposalAction= false,
                             deleteAction = false,
                             className = ''
                           }) {

  const { formatMessage } = useIntl()
  const { openEditPage, openDetailsPage, getDetailsPath, openProposalDialog, openDeleteDialog } = useModuleContext()
  const { id, slug, title, created_by, file_name, category, subcategory, description, user_id,
    skills = [], project_type, location, proposals = [], enabled,
    price, hours_per_week, duration, payment_term } = entity;
  const { authUser, isAuthorized } = useSelector( ({auth}) => ({ isAuthorized: !!auth.user, authUser:auth.user }), shallowEqual );

  // console.log(location)

  // Table pagination properties
  // const paginationOptions = {
  //   custom: true,
  //   totalSize: datasource.length,
  //   sizePerPageList: uiHelpers.sizePerPageList,
  //   sizePerPage: UIProps.queryParams.pageSize,
  //   page: UIProps.queryParams.pageNumber,
  // };

  /*TODO
  *  ROLES */

  // useEffect(()=>{
  //   console.log(getMenuItemByPathname(location.pathname))
  // }, [location.pathname])

  const isXs = size === "xs";
  const isSm = size === "sm";
  const isMd = size === "md";
  const isLg = size === "lg";

  const classes = {
    xs: {
      title: "",
      card: "",
      cardBody: "p-3"
    },
    sm: {
      title: "",
      card: "",
      cardBody: ""
    },
    md: {
      title: "",
      card: "",
      cardBody: ""
    },
  }

  const _classes = classes[size]

  let subTitleElements = [];
  switch (true){
    case isXs : {
      subTitleElements = [
        { text: id, svg:"/Shopping/Price2.svg" },
        { text: [category[localField()],subcategory[localField()]].join('/'), svg:"/Text/Menu.svg" },
      ];
    } break;
    case isSm : {
      subTitleElements = [
        { text: id, svg:"/Shopping/Price2.svg" },
        { text: category[localField()], svg:"/Text/Menu.svg" },
        { text: subcategory[localField()], svg:"/Text/Menu.svg" },
        { text: project_type[localField()], svg:"/Text/Menu.svg" },
        { text: [location[localField()],location.country[localField()]].join(' - '), svg:"/Map/Marker2.svg" },
      ];
    } break;
    case isMd : {
      subTitleElements = [
        { text: `@${created_by.username}`, svg:"/Communication/Contact1.svg", to:`/${CONTEXT}/${created_by.username}` },
        { text: created_by.legal_form[localField()], svg:"/Code/Info-circle.svg" },
        { text: category[localField()], svg:"/Text/Menu.svg" },
      ];
    } break;
  }

  const limit = 3

  if(size === 'xs'){
    return (
      <div className="d-flex">
        <div className="flex-grow-1">
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <div className="mr-3">
              <div className="d-flex align-items-center text-dark font-weight-bold mr-1">
                <AELink
                  to={getDetailsPath(slug)}
                  // onClick={event => openDetailsPage(slug)}
                >
                  {entity.title}
                </AELink>
                {
                  entity.is_saved &&
                  <i className="flaticon-black text-danger icon-md ml-2"/>
                }
              </div>
              <div className="d-flex flex-wrap my-1">
                {
                  [
                    { text: entity.id, svg:"/Shopping/Price2.svg" },
                    { text: [entity.category[localField()],entity.subcategory[localField()]].join('/'), svg:"/Text/Menu.svg" },
                  ].map(({text, svg}, index)=>
                    <a key={index} href="#" className="text-muted font-weight-bold pl-2">
                      {
                        svg &&
                        <AESVG
                          size={"sm"}
                          className={"svg-icon-gray-500 mr-1"}
                          path={svg}/>
                      }
                      {text}
                    </a>)
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
  return (
    // <div className="card card-custom gutter-b">
    <div className={"card card-custom gutter-b "+ className}>
      <div className="card-body">
        <div className="d-flex">
          <div className="flex-shrink-0 mr-7 mt-lg-0 mt-3">
            <AEAvatar entity={created_by} size={60}/>
          </div>
          <div className="flex-grow-1">
            <div className="d-flex align-items-center justify-content-between flex-wrap">
              <div className="mr-3">
                <div className="d-flex align-items-center text-dark font-size-h5 font-weight-bold mr-3">
                  <AELink
                    to={getDetailsPath(slug)}
                    // onClick={event => openDetailsPage(slug)}
                  >
                    {title}
                  </AELink>
                  {
                    entity.is_saved &&
                    <i className="flaticon-black text-danger icon-md ml-2"/>
                  }
                  {/*#<i className="flaticon2-correct text-primary icon-md ml-2"/>*/}
                  {/*#<i className="flaticon-star text-warning text-hover-warning icon-md ml-2"/>*/}
                  {/*<AESVG*/}
                  {/*  status={"warning"}*/}
                  {/*  icon={"/General/Star.svg"}*/}
                  {/*  size={""}*/}
                  {/*  />*/}
                  {/*<i className="flaticon2-correct text-warning icon-md ml-2"/>*/}
                </div>
                <div className="d-flex flex-wrap my-2">
                  {
                    subTitleElements.map(({text, svg, to = '#'}, index)=>
                      <a key={index} href={to} className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                        {
                          svg &&
                          <AESVG
                            size={"md"}
                            className={"svg-icon-gray-500 mr-1"}
                            path={svg}/>
                        }
                        {text}
                      </a>)
                  }
                </div>
              </div>
              <div className="my-lg-0 my-1 d-flex">
                {/*{*/}
                {/*  console.log( authUser.id, entity.user_id)*/}
                {/*}*/}
                {
                  deleteAction && authUser.id === entity.user_id &&
                  <AERole accept={[roles.client, roles.super_admin]}>
                    <AEButton
                      variant={'light-danger'}
                      fontWeight={'bolder'}
                      size={'sm'}
                      className={'text-uppercase mr-3'}
                      onClick={event => {openDeleteDialog(slug)}}
                    >
                      {formatMessage({id:"DELETE"})}
                    </AEButton>
                  </AERole>
                }
                {
                  editAction &&
                    <AERole accept={[roles.super_admin]}>
                      <AEButton
                        variant={'light-success'}
                        fontWeight={'bolder'}
                        size={'sm'}
                        className={'text-uppercase mr-3'}
                        onClick={event => {openEditPage(slug)}}
                      >
                        {formatMessage({id:"EDIT"})}
                      </AEButton>
                    </AERole>
                }
                {
                  detailsAction &&
                    <AELink
                      to={getDetailsPath(slug)}
                      className='btn btn-light-primary font-weight-bold text-uppercase'
                      // onClick={event => {
                      //   openDetailsPage(slug)
                      // }}
                    >
                      {formatMessage({id:"DETAILS"})}
                    </AELink>
                }
                { sendProposalAction && authUser !== entity.user_id &&
                  <AERole accept={[roles.provider]}>
                    <AEButton
                      variant={"light-primary"}
                      fontWeight={"bolder"}
                      className="text-uppercase"
                      onClick={event => {openProposalDialog(id)}}
                    >{formatMessage({id:"SEND_PROPOSAL"})}</AEButton>
                  </AERole>
                }
              </div>
            </div>
            {
              size !== "sm" &&
              <div className="d-flex align-items-center flex-wrap justify-content-between">
                <div className="flex-grow-1 font-weight-bold text-dark-50 py-5 py-lg-2 mr-5">
                  {/*{description}*/}
                  <AETruncate text={description} length={200} useWordBoundary />
                </div>

                {/*<div className="d-flex flex-wrap align-items-center py-2">*/}
                {/*  <div className="d-flex align-items-center mr-10">*/}
                {/*    <div className="mr-6">*/}
                {/*      <div className="font-weight-bold mb-2">Start Date</div>*/}
                {/*      <span className="btn btn-sm btn-text btn-light-primary text-uppercase font-weight-bold">*/}
                {/*        <AEMoment date={start_date}   />*/}
                {/*      </span>*/}
                {/*    </div>*/}
                {/*    <div className="">*/}
                {/*      <div className="font-weight-bold mb-2">Due Date</div>*/}
                {/*      <span className="btn btn-sm btn-text btn-light-danger text-uppercase font-weight-bold">*/}
                {/*        <AEMoment date={due_date} />*/}
                {/*      </span>*/}
                {/*    </div>*/}
                {/*  </div>*/}
                {/*<div className="flex-grow-1 flex-shrink-0 w-150px w-xl-300px mt-4 mt-sm-0">*/}
                {/*  <span className="font-weight-bold">Progress</span>*/}
                {/*  <div className="progress progress-xs mt-2 mb-2">*/}
                {/*    <div className="progress-bar bg-success" role="progressbar" style={{width:'60%'}}*/}
                {/*         aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"/>*/}
                {/*  </div>*/}
                {/*  <span className="font-weight-bolder text-dark">78%</span>*/}
                {/*</div>*/}
                {/*</div>*/}
              </div>
            }

          </div>
        </div>

        {
          size === "md" &&
            <>
              <div className="separator separator-solid my-5"/>

              <div className="d-flex align-items-center flex-wrap">
                <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                  <span className="mr-4">
                      <i className="flaticon-piggy-bank icon-2x text-muted font-weight-bold"/>
                  </span>
                  <div className="d-flex flex-column text-dark-75">
                    <span className="font-weight-bolder font-size-sm">
                      {formatMessage({id:"PRICE"})}
                      <span className="label label-sm label-light-dark label-inline ml-2">

                        {formatMessage({id:`DB.PAYMENT_TERM.${payment_term._key}`})}
                      </span>
                    </span>
                    <span className="font-weight-bolder font-size-h5">
                      {
                        payment_term._key !== PAYMENT_TERMS.UNKNOWN ? <AECurrency value={price} /> : '--'
                      }
                      {
                        payment_term._key === PAYMENT_TERMS.HOURLY && formatMessage({id:'PER_HOUR.SHORT'})
                      }
                      {/*<span className="text-dark-50 font-weight-bold">/h</span>*/}
                    </span>
                  </div>
                </div>
                <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                  <span className="mr-4">
                      <i className="flaticon-confetti icon-2x text-muted font-weight-bold"/>
                  </span>
                  <div className="d-flex flex-column text-dark-75">
                    <span className="font-weight-bolder font-size-sm">{formatMessage({id:"SUBCATEGORY"})}</span>
                    <span className="font-weight-bolder font-size-h5">
                      <span className="label label-lg label-light-success label-inline">{subcategory[localField()]}</span>
                      {/*<AEButton> </AEButton>*/}
                    </span>
                  </div>
                </div>

                <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                  <span className="mr-4">
                      <i className="flaticon-confetti icon-2x text-muted font-weight-bold"/>
                  </span>
                  <div className="d-flex flex-column text-dark-75">
                    <span className="font-weight-bolder font-size-sm">{formatMessage({id:"SKILL.COUNT"},{count:skills.length})}</span>
                    <span className="font-weight-bolder font-size-h5">
                      {
                        skills.slice(0, 2).map(o=>(
                          <span key={o.id} className="label label-light label-inline m-1">
                            {o[localField()]}
                          </span>
                        ))
                      }
                      {
                        skills.length > 2 &&
                        <span className="label label-light label-inline m-1"> {skills.length-2}+ </span>
                      }
                    </span>
                  </div>
                </div>

                {/*<div className="d-flex align-items-center flex-lg-fill mr-5 my-1">*/}
                {/*  <span className="mr-4">*/}
                {/*      <i className="flaticon-pie-chart icon-2x text-muted font-weight-bold"/>*/}
                {/*  </span>*/}
                {/*  <div className="d-flex flex-column text-dark-75">*/}
                {/*    <span className="font-weight-bolder font-size-sm">Net</span>*/}
                {/*    <span className="font-weight-bolder font-size-h5"><span*/}
                {/*      className="text-dark-50 font-weight-bold">$</span>782,300</span>*/}
                {/*  </div>*/}
                {/*</div>*/}
                {/*<div className="d-flex align-items-center flex-lg-fill mr-5 my-1">*/}
                {/*<span className="mr-4">*/}
                {/*    <i className="flaticon-file-2 icon-2x text-muted font-weight-bold"/>*/}
                {/*</span>*/}
                {/*  <div className="d-flex flex-column flex-lg-fill">*/}
                {/*    <span className="text-dark-75 font-weight-bolder font-size-sm">73 Tasks</span>*/}
                {/*    <a href="#" className="text-primary font-weight-bolder">View</a>*/}
                {/*  </div>*/}
                {/*</div>*/}
                {
                  isAuthorized &&
                  <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                    <span className="mr-4">
                        <i className="flaticon-network icon-2x text-muted font-weight-bold"/>
                    </span>
                    <div className="d-flex flex-column">
                      <span className="text-dark-75 font-weight-bolder font-size-sm">
                        {formatMessage({id:"PROPOSAL.COUNT"},{count:proposals.length})}
                      </span>
                      {/*<a href="#" className="text-primary font-weight-bolder">View</a>*/}


                      <div className="symbol-group symbol-hover">
                        {
                          proposals.slice(0, limit).map((p)=>
                              <AEAvatar
                                key={p.id}
                                entity={p.created_by}
                                size={30}
                              />
                            )
                        }
                        {
                          proposals.length > 3 &&
                          <div className="symbol symbol-30 symbol-circle symbol-light">
                            <span className="symbol-label font-weight-bold">{proposals.length-limit}+</span>
                          </div>
                        }

                      </div>
                    </div>
                  </div>
                }
                {/*{*/}
                {/*  isAuthorized &&*/}
                {/*  <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">*/}
                {/*    <span className="mr-4">*/}
                {/*        <i className="flaticon-network icon-2x text-muted font-weight-bold"/>*/}
                {/*    </span>*/}
                {/*    <div className="d-flex flex-column">*/}
                {/*      <span className="text-dark-75 font-weight-bolder font-size-sm">*/}
                {/*        {formatMessage({id:"MEMBER.COUNT"},{count:proposals.length})}*/}
                {/*      </span>*/}
                {/*      /!*<a href="#" className="text-primary font-weight-bolder">View</a>*!/*/}
                {/*      <div className="symbol-group symbol-hover">*/}
                {/*        <div className="symbol symbol-30 symbol-circle" data-toggle="tooltip" title="Mark Stone">*/}
                {/*          <img alt="" src={toAbsoluteUrl(`/media/users/300_25.jpg`)}/>*/}
                {/*        </div>*/}

                {/*        <div className="symbol symbol-30 symbol-circle" data-toggle="tooltip" title="Teresa Fox">*/}
                {/*          <img alt="" src={toAbsoluteUrl(`/media/users/300_18.jpg`)}/>*/}
                {/*        </div>*/}
                {/*        <div className="symbol symbol-30 symbol-circle symbol-light">*/}
                {/*          <span className="symbol-label font-weight-bold">5+</span>*/}
                {/*        </div>*/}
                {/*      </div>*/}
                {/*    </div>*/}
                {/*  </div>*/}
                {/*}*/}

              </div>
            </>
        }

      </div>
    </div>
  );
}
